var React = require('react');

function IconAdd (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M47 0h5.9v100H47z","key":0}),React.createElement("path",{"d":"M0 47.1h100V53H0z","key":1})]);
}

IconAdd.defaultProps = {"className":"icon add","viewBox":"0 0 100 100"};

module.exports = IconAdd;

IconAdd.default = IconAdd;



//////////////////
// WEBPACK FOOTER
// ./src/media/icon-add.svg
// module id = 520
// module chunks = 0